export const SELECTED_LANGUAGE = 'lang';
